'use strict';

var XtFormDirective = function XtFormDirective($timeout) {
  return {
    require: '',
    priority: -1,
    controller: 'xtFormController',
    controllerAs: 'xtForm',
    link: function link(scope, element, attrs, xtForm) {
      element.on('submit', function () {
        scope.$apply(function () {
          xtForm.submit();
        });
      }).on('reset', function () {
        $timeout(function () {
          xtForm.reset();
        });
      });
    }
  };
};
XtFormDirective.$inject = ['$timeout'];
module.exports = XtFormDirective;